import React from 'react'

import AddToButton from '../AddToButton'
import SoundCheckButton from '../SoundCheckButton'
import EditScoreButton from './EditScoreButton'
import UnpublishButton from './UnpublishButton'

const PublisherControls: React.FC = () => {
  return (
    <div className="flex flex-col gap-2">
      <AddToButton />
      <SoundCheckButton />
      <EditScoreButton />
      <UnpublishButton />
    </div>
  )
}

export default PublisherControls
